module.exports = __webpack_public_path__ + "static/media/a48.f820d17e.jpg";